import * as React from "react";
import { Choose } from "react-extras";
import { getOnboardData } from "../../libs/onboard";
import Button from "../core/Button";
import Loader from "../core/Loader";
import Modal from "../core/Modal";
import Panel from "../core/Panel";
import CompanyInfoGrabForm from "../onboarding/CompanyInfoGrabForm";
import { saveOrg, saveOrgData } from "../../libs/organization";
import ToggleOnboardComplete from "./ToggleOnboardComplete";

function HardwareOption({
  hardwareOption,
}: {
  hardwareOption: IOnboardDataAttributes["hardwareOption"];
}) {
  return (
    <Choose>
      <Choose.When condition={hardwareOption === "haas"}>
        <span className="label label-success">HaaS</span>
      </Choose.When>
      <Choose.When condition={hardwareOption === "purchase"}>
        <span className="label label-success">Purchase</span>
      </Choose.When>
      <Choose.When condition={hardwareOption === "opt_out"}>
        <span className="label label-info">Opt-Out</span>
      </Choose.When>
      <Choose.Otherwise>
        <span className="label label-default">Not Chosen Yet</span>
      </Choose.Otherwise>
    </Choose>
  );
}

interface IProps {
  org: IOrganization;
  fetchOrg: () => void;
}

interface IState {
  onboardData?: IOnboardDataRecord;
  loading: boolean;
  infoGrabModalOpen: boolean;
  togglingComplete: boolean;
}

class OrgOnboardData extends React.Component<IProps, IState> {
  state: Readonly<IState> = {
    loading: true,
    infoGrabModalOpen: false,
    togglingComplete: false,
  };

  componentDidMount() {
    getOnboardData(this.props.org).then(resp => {
      this.setState({ onboardData: resp.data, loading: false });
    });
  }

  toggleOnboardComplete = async () => {
    const { org, fetchOrg } = this.props;

    this.setState({ togglingComplete: true });

    if (org.onboardingStepsData) {
      const current = org.onboardingStepsData.dontReturnOnLogin;
      org.onboardingStepsData.dontReturnOnLogin = !current;
    } else {
      org.onboardingStepsData = { dontReturnOnLogin: true };
    }

    await saveOrg(org);
    await fetchOrg();

    this.setState({ togglingComplete: false });
  };

  render() {
    const { onboardData, loading, infoGrabModalOpen } = this.state;
    const { org } = this.props;

    if (loading || !onboardData) {
      return <Loader />;
    }

    const { onboardingStepsData } = org;

    // determine if onboarding is complete
    let onboardComplete = false;
    if (onboardingStepsData && onboardingStepsData.dontReturnOnLogin) {
      onboardComplete = true;
    }

    const {
      hardwareOption,
      hardwareFiles,
      hardwareData,
      companyInfoGrabFiles: infoGrabFiles,
    } = onboardData.attributes;

    return (
      <>
        <h2>Admin Onboarding View</h2>
        <ToggleOnboardComplete
          complete={onboardComplete}
          toggle={this.toggleOnboardComplete}
          toggling={this.state.togglingComplete}
        />
        <div className="columns">
          <div className="column is-half">
            <Panel heading={"Company Info Grab"}>
              <Button
                onClick={() => this.setState({ infoGrabModalOpen: true })}
              >
                View Form Info
              </Button>
              <hr />
              <div className="columns">
                <div className="column is-narrow">
                  <Panel>
                    <p>
                      <strong>Uploaded Files</strong>
                    </p>
                    {infoGrabFiles && infoGrabFiles.length > 0 ? (
                      infoGrabFiles.map(f => (
                        <div key={f.url}>
                          <a target={"_blank"} href={f.url} rel="noopener noreferrer">
                            {f.name}
                          </a>
                        </div>
                      ))
                    ) : (
                      <p>Nothing yet.</p>
                    )}
                  </Panel>
                </div>
              </div>
            </Panel>
          </div>
          <div className="column is-half">
            <Panel heading={"Hardware"}>
              <strong>Hardware Option:</strong>{" "}
              <HardwareOption hardwareOption={hardwareOption} />
              <p>&nbsp;</p>
              <table className="table">
                <tbody>
                  <tr>
                    <td>Signed Credit Application</td>
                    <td>
                      {hardwareData && hardwareData.signedCreditApplication ? (
                        <i className={"fa fa-2x fa-check fa-fw text-success"} />
                      ) : (
                        <i className={"fa fa-2x fa-times fa-fw"} />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Signed HaaS Addendum</td>
                    <td>
                      {hardwareData && hardwareData.signedHaasAddendum ? (
                        <i className={"fa fa-2x fa-check fa-fw text-success"} />
                      ) : (
                        <i className={"fa fa-2x fa-times fa-fw"} />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="columns">
                <div className="column is-narrow">
                  <Panel>
                    <p>
                      <strong>Uploaded Files</strong>
                    </p>
                    {hardwareFiles && hardwareFiles.length > 0 ? (
                      hardwareFiles.map(f => (
                        <div key={f.url}>
                          <a target={"_blank"} href={f.url} rel="noopener noreferrer">
                            {f.name}
                          </a>
                        </div>
                      ))
                    ) : (
                      <p>Nothing yet.</p>
                    )}
                  </Panel>
                </div>
              </div>
            </Panel>
          </div>
        </div>
        <Modal
          title={"Company Info"}
          open={infoGrabModalOpen}
          close={() => this.setState({ infoGrabModalOpen: false })}
        >
          <CompanyInfoGrabForm
            readOnly
            infoGrabData={onboardData.attributes.companyInfoGrab}
          />
        </Modal>
      </>
    );
  }
}

export default OrgOnboardData;



// WEBPACK FOOTER //
// ./app/javascript/components/admin/OrgOnboardData.tsx